import React from "react";
import { Avatar, Box, HStack, Text, VStack } from "@chakra-ui/react";
import { FaTrophy } from "react-icons/fa";
import { Panel, EmptyState } from "../ui";
import { getUserDisplayName } from "./dashboardUtils";

const POSITION_STYLES = {
  1: { height: "180px", bg: "linear-gradient(135deg,#0B1F3A 0%,#1E4D78 100%)" },
  2: { height: "148px", bg: "linear-gradient(135deg,#1E4D78 0%,#3A6B96 100%)" },
  3: { height: "120px", bg: "linear-gradient(135deg,#1BAE9A 0%,#3FCBB7 100%)" },
};

const RankingPodiumCard = ({ title, items, metricLabelBuilder, emptyLabel }) => {
  const podiumItems = items.slice(0, 3);
  const orderedItems =
    podiumItems.length >= 3
      ? [podiumItems[1], podiumItems[0], podiumItems[2]].filter(Boolean)
      : podiumItems;

  return (
    <Panel title={title}>
      {podiumItems.length === 0 ? (
        <EmptyState icon={<FaTrophy />} title={emptyLabel} />
      ) : (
        <Box p="16px">
          <HStack align="end" spacing="12px" minH="220px">
            {orderedItems.map((item) => {
              const rank = item.rank;
              const style = POSITION_STYLES[rank] || POSITION_STYLES[3];
              const name = getUserDisplayName(item);
              return (
                <VStack key={`${title}-${item.user_id}`} flex="1" spacing="12px" align="stretch">
                  <VStack spacing="6px">
                    <Avatar
                      size="md"
                      name={name}
                      src={item.avatar_url || undefined}
                      bg="portal.active"
                      color="portal.primary"
                    />
                    <Text
                      fontSize="12px"
                      fontWeight="800"
                      color="portal.text"
                      textAlign="center"
                      noOfLines={2}
                      sx={{ marginBottom: "0 !important" }}
                    >
                      {name}
                    </Text>
                    <Text
                      fontSize="11px"
                      color="portal.muted"
                      textAlign="center"
                      sx={{ marginBottom: "0 !important" }}
                    >
                      {metricLabelBuilder(item)}
                    </Text>
                  </VStack>

                  <Box
                    borderRadius="10px"
                    bg={style.bg}
                    h={style.height}
                    display="flex"
                    alignItems="flex-end"
                    justifyContent="center"
                    pb="16px"
                    boxShadow="kpi"
                  >
                    <Text fontSize="24px" fontWeight="900" color="white" sx={{ marginBottom: "0 !important" }}>
                      {rank}
                    </Text>
                  </Box>
                </VStack>
              );
            })}
          </HStack>
        </Box>
      )}
    </Panel>
  );
};

export default RankingPodiumCard;
